
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'bootstrap/dist/js/bootstrap.bundle.min';
import 'bootstrap/dist/css/bootstrap.min.css';

import { loadUserNoAuth } from './actions/sharedActions';

import { Provider } from 'react-redux';
import { store } from './store/store';
import { loadUser } from './actions/sharedActions';


import { msalInstance } from './api/sharedAPI'; // Adjust path if your msalInstance is elsewhere

/*AZURE METHOD NEW FOR 2026*/
import * as msal from "@azure/msal-browser";

const root = ReactDOM.createRoot(document.getElementById('root'));
//store.dispatch(loadUser());
//store.dispatch(loadUserNoAuth());

/*
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>
);
*/

async function renderApp() {
    try {
        await msalInstance.initialize();

        // 1. Check the URL for Azure response markers BEFORE doing anything
        const isReturningFromAzure = window.location.hash.includes("code=") || 
                                    window.location.hash.includes("id_token=") || 
                                    window.location.hash.includes("state=");

        // 2. Handle the redirect
        const response = await msalInstance.handleRedirectPromise();
        
        if (response) {
            msalInstance.setActiveAccount(response.account);
        }

        // 3. Get the current account status
        const allAccounts = msalInstance.getAllAccounts();
        const activeAccount = msalInstance.getActiveAccount() || allAccounts[0];

        // 4. THE NUCLEAR GUARD
        if (!activeAccount) {
            // If we have markers in the URL, MSAL is busy processing. DO NOT REDIRECT.
            if (isReturningFromAzure) {
                console.log("MSAL is processing redirect tokens. Standing by...");
                return; // Hard stop—let the page finish processing or auto-refresh
            }

            // No user and no markers? THEN we redirect.
            console.log("No account found. Redirecting to login...");
            await msalInstance.loginRedirect({
                scopes: ["User.Read"],
                prompt: "select_account"
            });
            return;
        }

        // 5. Success Path: Only boot the app if we have a solid account
        msalInstance.setActiveAccount(activeAccount);
        store.dispatch(loadUser());

        root.render(
            <Provider store={store}>
                <App />
            </Provider>
        );

    } catch (error) {
        // If the bouncer says the door is busy, we just walk away and wait.
        if (error.errorCode === "interaction_in_progress") {
            console.warn("Authentication interaction in progress. Application boot deferred.");
            return;
        }
        console.error("Auth Error:", error);
    }
}

renderApp();

reportWebVitals();

